"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var config_service_1 = require("@fuse/services/config.service");
var router_1 = require("@angular/router");
var registration_service_1 = require("app/main/content/_service/registration.service");
var user_1 = require("app/main/content/_model/user");
var equals_validator_1 = require("app/main/content/_validator/equals.validator");
var string_unique_validator_1 = require("app/main/content/_validator/string-unique.validator");
var VolunteerRegistrationComponent = /** @class */ (function () {
    function VolunteerRegistrationComponent(fuseConfig, formBuilder, router, registrationService) {
        this.fuseConfig = fuseConfig;
        this.formBuilder = formBuilder;
        this.router = router;
        this.registrationService = registrationService;
        this.today = new Date();
        var layout = {
            navigation: 'none',
            toolbar: 'none',
            footer: 'none',
        };
        this.fuseConfig.setConfig({ layout: layout });
        this.registrationFormErrors = {
            username: {},
            password: {},
            confirmPassword: {},
            email: {},
            firstName: {},
            lastName: {},
            birthday: {},
        };
    }
    VolunteerRegistrationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.registrationForm = this.formBuilder.group({
            username: new forms_1.FormControl('', forms_1.Validators.required),
            password: new forms_1.FormControl('', forms_1.Validators.required),
            confirmPassword: new forms_1.FormControl(''),
            email: new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.pattern(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)]),
            firstName: new forms_1.FormControl('', forms_1.Validators.required),
            lastName: new forms_1.FormControl('', forms_1.Validators.required),
            birthday: new forms_1.FormControl('', forms_1.Validators.required),
        });
        this.registrationForm.valueChanges.subscribe(function () {
            _this.onRegistrationFormValuesChanged();
        });
        this.registrationForm.controls['confirmPassword'].setValidators([forms_1.Validators.required, equals_validator_1.equals(this.registrationForm.controls['password'], this.registrationForm.controls['confirmPassword'])]);
    };
    VolunteerRegistrationComponent.prototype.onRegistrationFormValuesChanged = function () {
        for (var field in this.registrationFormErrors) {
            if (!this.registrationFormErrors.hasOwnProperty(field)) {
                continue;
            }
            // Clear previous errors
            this.registrationFormErrors[field] = {};
            // Get the control
            var control = this.registrationForm.get(field);
            if (field === 'confirmPassword' || field === 'password' || field === 'email' || field === 'username') {
                control.updateValueAndValidity({ onlySelf: true });
            }
            if (control && control.dirty && !control.valid) {
                this.registrationFormErrors[field] = control.errors;
            }
        }
    };
    VolunteerRegistrationComponent.prototype.register = function () {
        var _this = this;
        if (!this.registrationForm.valid) {
            return;
        }
        var volunteer = new user_1.User();
        volunteer.username = this.registrationForm.value.username;
        volunteer.password = this.registrationForm.value.password;
        volunteer.loginEmail = this.registrationForm.value.email;
        volunteer.emails = [];
        volunteer.emails.push(this.registrationForm.value.email);
        volunteer.firstname = this.registrationForm.value.firstName;
        volunteer.lastname = this.registrationForm.value.lastName;
        volunteer.birthday = this.registrationForm.value.birthday;
        this.registrationService.registerUser(volunteer, user_1.AccountType.PERSON)
            .toPromise().then(function (response) {
            _this.loginFormWrapper.nativeElement.scrollTo(0, 0);
            _this.displaySuccess = true;
        }).catch(function (response) {
            if (response.error.response === 'USERNAME') {
                _this.registrationForm.controls['username'].setValidators([forms_1.Validators.required, string_unique_validator_1.stringUniqueValidator([volunteer.username])]);
            }
            if (response.error.response === 'EMAIL') {
                _this.registrationForm.controls['email'].setValidators([forms_1.Validators.required, string_unique_validator_1.stringUniqueValidator([volunteer.loginEmail])]);
            }
            _this.onRegistrationFormValuesChanged();
        });
    };
    VolunteerRegistrationComponent.prototype.handleBackClick = function () {
        window.history.back();
    };
    VolunteerRegistrationComponent.prototype.handleBackToLoginClick = function () {
        this.router.navigate(['/login']);
    };
    return VolunteerRegistrationComponent;
}());
exports.VolunteerRegistrationComponent = VolunteerRegistrationComponent;
